<template>
  <div>
    <video
      v-if="canPlayWebM"
      :style="{ height: height + 'px', width: width + 'px' }"
      preload="auto"
      autoplay
      loop
      muted
      playsinline
    >
      <source :src="require('@/assets/loaderV4.webm')" type="video/webm" />
    </video>

    <img
      v-else
      :src="require('@/assets/loaderV2-optimized.gif')"
      alt="Loader spinner"
      :style="{ height: height + 'px', width: width + 'px' }"
    />
  </div>
</template>

<script>
export default {
  name: 'LoaderSpinner',
  props: {
    height: {
      type: Number,
      default: 185
    },
    width: {
      type: Number,
      default: 185
    }
  },
  data () {
    return {
      canPlayWebM: false
    }
  },
  mounted () {
    const video = document.createElement('video')
    const isWebMSupported =
      video.canPlayType('video/webm; codecs="vp8, vorbis"') !== ''

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

    // Disable WebM for Safari (macOS or iOS)
    this.canPlayWebM = isWebMSupported && !isIOS && !isSafari
  }
}
</script>

<style scoped>
</style>
